// TODO: Deprecate JS logic on the Advanced Search Page
//		 Instead, use standard HTML forms to submit advanced 
//		 search queries. Presentation JS should be moved to 
//		 other global script files and any advancedsearch.js
//		 files should be deleted.


// Advanced Search
// ========================================

var SCM = SCM || {};

SCM.AdvancedSearch = {};

SCM.AdvancedSearch.configSettings = {
    preSelectSingleBookFacet: 'true'
};


// ----
// Global Variables
// ----

var textCharectorLimit = $('#hfSolrMaxAllowSearchChar').val(); // hidden field on the master page of the client


// ----
// Add Subscription Parameter to URL
// ----

function AppendSubscriptionParameterToUrl(redirectUrl) {

    var subOnlyParam = '&subonly=true',
        isSubOnly = $('#hfEnableSubscriptionFilter').val().toLowerCase() == 'true',
        url = redirectUrl;

    // check for subscription only value
    if (isSubOnly) {
        // add the subscription parameter to the URL
        var url = redirectUrl + subOnlyParam;
    }

    return url;
}


// ----
// Date
// ----

//For todays date;
// Source: http://stackoverflow.com/questions/10211145/getting-current-date-and-time-in-javascript
Date.prototype.today = function () {
    return (((this.getMonth() + 1) < 10) ? '0' : '') + (this.getMonth() + 1) + '/' + ((this.getDate() < 10) ? '0' : '') + this.getDate() + '/' + this.getFullYear();
};

// set the character limit if none is already set
if (textCharectorLimit == null || textCharectorLimit == '') {
    textCharectorLimit = '255';
}

// compose a valid date
function isValidDate(date) {
    var matches = /^(\d{2})[-\/](\d{2})[-\/](\d{4})$/.exec(date);
    if (matches == null) return false;
    var d = matches[2];
    var m = matches[1] - 1;
    var y = matches[3];
    var composedDate = new Date(y, m, d);
    return composedDate.getDate() == d &&
            composedDate.getMonth() == m &&
            composedDate.getFullYear() == y;
}

// check if its only a year
function isYearOnly(date) {
    var matches = /^(\d{4})$/.exec(date);

    return matches && matches[1] > -1;
}

// change year only entrees to full formed dates
function updateYearOnlyToFullDate(dateTxtField, isStartDate) {
    var year = dateTxtField.val();
    var month = null;
    var day = null;
    if (isStartDate) {
        month = '01';
        day = '01';
    } else {
        month = '12';
        day = '31';
    }

    dateTxtField.val(month + '/' + day + '/' + year);

    return dateTxtField.val();
}


// ----
// Set Search Scope
// ----

var micrositeJournalDisplayName = '';
var micrositeJournalId = '';
var solrsearchScope = $('#hfSolrJournalID').val();
var solrBookSearchScope = $('#hfSolrBookID').val();

// TODO: Handle undefined scope

if (typeof solrsearchScope === 'undefined') {
    solrsearchScope = ''; //default it to empty string
} else {
    if (solrsearchScope != null) {
        solrsearchScope = solrsearchScope.replace('J', '');
    }
}

if (typeof solrBookSearchScope === 'undefined') {
    solrBookSearchScope = ''; //default it to empty string
} else {
    if (solrBookSearchScope != null) {
        solrBookSearchScope = solrBookSearchScope.replace('B', '');
    }
}


$(document).ready(function (event) {
    $(document).on('click', '.access-filter-input-radio', function () {
        if ($(this).attr('value') === 'contentowned') {
            $('#rbtAllContent').prop('checked', false);
        } else {
            $('#rbtContentOwned').prop('checked', false);
        }
    });

    function doOwnedContentSearch(queryStringData) {
        var contentOwnedQuery = $('.access-filter-input-radio[value=contentowned]').is(':checked');
        
        if (contentOwnedQuery) {
            queryStringData.access_openaccess = true;
            queryStringData.access_free = true;
            queryStringData.access_unlocked = true;
        }
    }


    // ----
    // Check Boxes
    // ----

    // if not looking for books
    if (solrBookSearchScope == null || solrBookSearchScope == '') {

        // 1) disable all books check boxes
        $('#advancedSearch input.advancedSearchBook[type=checkbox]').each(function () {
            $(this).prop('checked', false);
            $(this).prop('disabled', true);
        });

        $('.advancedAuthorSearch input.advancedSearchBook[type=checkbox]').each(function () {
            $(this).prop('checked', false);
            $(this).prop('disabled', true);
        });


        // 2) uncheck books radio button 
        $('input.rbPublication[type=radio]').each(function () {
            var isAllBooks = $(this).attr('value') == 'B*' ? true : false;
            if (isAllBooks) {
                $(this).prop('checked', false);
            } else {
                $(this).prop('checked', true);
            }
        });

    } else {
        // it is a book search so.. disable journal stuff

        //1) check boxes
        $('#advancedSearch input.advancedSearchJournal[type=checkbox]').each(function () {
            $(this).prop('checked', false);
            $(this).prop('disabled', true);
        });

        $('.advancedAuthorSearch input.advancedSearchJournal[type=checkbox]').each(function () {
            $(this).prop('checked', false);
            $(this).prop('disabled', true);
        });


        // 2) uncheck books radio button 
        $('input.rbPublication[type=radio]').each(function () {
            var isAllJournals = $(this).attr('value') == 'J*' ? true : false;
            if (isAllJournals) {
                $(this).prop('checked', false);
            } else {
                $(this).prop('checked', true);
            }
        });
    }


    // preselect the journal for check box and drop down.
    if ((solrsearchScope != null && solrsearchScope != '') || (solrBookSearchScope != null && solrBookSearchScope != '')) {
        $('.advancedAuthorSearch input:checkbox').each(function () {
            var currentDisplayName = $(this).attr('currentjournaldisplayname');
            var currentText = $(this).attr('text');
            var journalId = $(this).attr('jid');
            var bookId = $(this).attr('bid');
            if (currentDisplayName != null & currentText != null && currentDisplayName == currentText) {
                if (journalId == solrsearchScope) {
                    // alert(journalId);
                    this.checked = true;

                    //get the journal display Name for the microsite journal.
                    micrositeJournalDisplayName = currentText;
                    micrositeJournalId = journalId;

                    //exit loop
                    return false;
                }
            } else if (bookId != null && bookId != '') {
                if (bookId == solrBookSearchScope || solrBookSearchScope === '*') {
                    this.checked = true;
                }
            }
        });

        $('#advancedSearch input:checkbox').each(function () {
            var currentDisplayName = $(this).attr('currentjournaldisplayname');
            var currentText = $(this).attr('text');
            var journalId = $(this).attr('jid');
            var bookId = $(this).attr('bid');

            if (currentDisplayName != null & currentText != null && currentDisplayName == currentText) {
                if (journalId == solrsearchScope) {
                    // alert(journalId);
                    this.checked = true;

                    //get the journal display Name for the microsite journal.
                    micrositeJournalDisplayName = currentText;
                    micrositeJournalId = journalId;

                    //exit loop
                    return false;
                }
            } else if (bookId != null && bookId != '') {
                //alert('Book ID in advancedSearch is ::' + bookId);
                if (bookId == solrBookSearchScope || solrBookSearchScope === '*') {
                    this.checked = true;
                }
            }
        });

        $('.citationJournal').each(function () {
            $('option', this).each(function () {
                var jarrayItemValue = $(this).val().split(',');
                if (jarrayItemValue != null && jarrayItemValue[0] == 'C') {
                    var journalId = jarrayItemValue[1];
                    if (journalId == solrsearchScope) {
                        // alert(journalId);
                        $(this).prop('selected', true);
                    }
                }
            });
        });

    }

    resetContentTypeFilter();

    // ----
    // Title Search
    // ----

    //Title Search function used for the button click and Default behavior of the Title text field.
    function doTitleSearch(title) {

        if (title == null || title == '') {
            alert('Please enter a term to search');
            return;
        } else if (title.length > parseInt(textCharectorLimit)) {
            alert('Please enter a term between 1 to ' + textCharectorLimit + ' characters');
            return;
        } else {

            var queryStringData = {};

            doOwnedContentSearch(queryStringData);

            var articleTitle = '"' + title + '"';          

            // Guaranteed to be all journal search since adv search is always on umbrella
            queryStringData.allJournals = 1;

            queryStringData.q = articleTitle;
            queryStringData.fd_ArticleTitle = articleTitle;

            performSearch(queryStringData);
        }
    }

    $(document).on('click', '#btnAdvancedTitleSearch', function () {
        var searchTerm = $('#articleTitle').val();
        doTitleSearch(searchTerm);
    });

    $(document).on('keydown', '#articleTitle', function (e) {
        if (e.keyCode == 13) {
            var searchTerm = $('#articleTitle').val();
            doTitleSearch(searchTerm);
        }
    });

    function resetContentTypeFilter() {
        $('#contentTypeFilters input:checkbox').prop('checked', false);
        $('#advancedSearch #chkAdvancedSearchContentType').each(function () {
            var checkBoxVal = $(this).attr('value');
            if (checkBoxVal === 'Journal Article' | checkBoxVal === 'Book' | checkBoxVal === 'Book Chapter' | checkBoxVal === 'GeoRef Record') {
                $(this).prop('checked', true);
            }
        });
    }

    // ----
    // Citation Search
    // ----

    //Citation Search
    function doAdvancedCitationSearch() {

        var ctYearValue = $('#citationYear').val();
        var ctVolumeValue = $('#citationVolume').val();
        var volumePattern = $('#citationVolume').attr('pattern');
        var ctStartPageValue = $('#citationPage').val();
        var ctJournalValue = $('.citationJournal').val();
        var journalDisplayName = $('.citationJournal option:selected').text();
        var isCurrentJournal = false;

        var ctIssueNoValue = '';
        if ($('#citationIssueNo').length) {
            ctIssueNoValue = $('#citationIssueNo').val();
        }

        var citationData = {};
        var validationMessage = '';

        if (ctJournalValue == null || ctJournalValue == '' || ctJournalValue == '- Select a Journal') {
            validationMessage = 'Please select a journal.' + '\n';
        }

        //YEAR
        if (ctYearValue != null && ctYearValue != '' && ctYearValue != 'Yr') {
            if (isNaN(ctYearValue)) {
                validationMessage = validationMessage + 'Year must be numeric.' + '\n';
            } else {
                //var rangequery = ctYearValue + '-01-01T00:00:00.000Z TO ' + ctYearValue + '-12-31T23:59:59.000Z';
                //Instead of using the ISO format, just using the MM/DD/YYYY format
                var rangequery = '01/01/' + ctYearValue + ' TO ' + '12/31/' + ctYearValue;
                citationData.rg_PublicationDate = rangequery;
            }
        }


        //VOLUME
        if (ctVolumeValue != null && ctVolumeValue != '' && ctVolumeValue != 'Vol') {
            var volumeRegex = new RegExp(volumePattern);
            if (volumeRegex.test(ctVolumeValue)) {
                citationData.fd_Volume = ctVolumeValue;
            } else {
                validationMessage = validationMessage + 'Volume must be alphanumeric without spaces';
            }
        }

        if (ctIssueNoValue !== null && ctIssueNoValue !== '' && ctIssueNoValue !== 'Issue') {
            citationData.fd_IssueNo = ctIssueNoValue;
        }

        if (ctStartPageValue != '' && ctStartPageValue != '1st Pg') {
            citationData.fd_StartPage = ctStartPageValue;
        }

        if (validationMessage.length > 0) {
            //validation failed!
            alert(validationMessage);
            return false;
        }

        //CSV will contain 3 elements: First element will be either "C" (current journal) or "L" (legacy journal);Second element will be the JournalID;Third element will be JournalHistoricalAttributesID
        var jarray = ctJournalValue.split(',');
        if (jarray[0] == 'C') {
            //Current Journal: Results should include all articles from current journal and all the legacy journals associated with it.
            //Pass just the JournalID
            citationData.fl_JournalID = jarray[1];
            isCurrentJournal = true;

        } else {
            //Legacy: Results should include only articles published under this legacy journal name.
            //Pass the LegacyHistID to get accurate results.
            citationData.fl_JournalHistID = jarray[2];
        }

        //Pass Journal Display Name so Journal is preselected on the results page and ArticleClientType facet (dependent on JournalDisplayName) is displayed!
        //Encode the JournalDisplayName to make sure DisplayNames which have "&" or "-" or other characters are intrepreted correctly.

        //Add Relevancy Parameter
        //var wildCardCharacter = "\"" + "*:*" + "\"";
        //citationData.exPrm_qqq = "{!payload_score f=Tags func=max v=q$}" + wildCardCharacter;

        doOwnedContentSearch(citationData);

        var redirectUrl = '/search-results?' + $.param(citationData);

        //NOTE:
        //It appears (http://api.jquery.com/jQuery.param/) it is not possible to encode using jQuery.param( obj )
        //As a result, journalFacetName is appended to the redirectUrl variable below (after it is encoded using encodeURIComponent)
        //Journal Display Name needs to be URL encoded
        //ToDo:Because the Journal list includes legacy journals, when a legacy journal is selected, ArticleClientType facet will not be displayed because the ArticleClientType facet depends on JournalDisplayName and not LegacyJournalDisplayName.
        var journalFacetName = '';  //encodeURIComponent($.trim(journalDisplayName));
        if (isCurrentJournal) {
            journalFacetName = '&f_JournalDisplayName=' + encodeURIComponent($.trim(journalDisplayName));
        } else {
            //ToDo:Revisit this!
            //We can certainly make "LegacyJournalDisplayName" a facet and then create a dependency between LegacyJournalDisplayName & ArticleClientType but
            journalFacetName = '&fd_LegacyJournalDisplayName=' + encodeURIComponent($.trim(journalDisplayName));
        }

        redirectUrl = redirectUrl + journalFacetName;

        var searchSiteUrl = $('#hfSiteURL').val();
        window.location.href = window.location.protocol + '//' + searchSiteUrl + redirectUrl + '&searchType=advanced';
        return false;
    }

    //Citation Search Click
    $(document).on('click', '#btnAdvancedCitationSearch', function () {
        doAdvancedCitationSearch();
    });

    //Enter key -- Advanced Citation Search
    $('#btnAdvancedCitationSearch').keyup(function (e) {
        if (e.keyCode == 13) {
            e.preventDefault();
            doAdvancedCitationSearch();
        }
    });

    function doContentTypeFilterSearch(queryStringData) {

        var contentTypeFilter = null;

        $('#advancedSearch #chkAdvancedSearchContentType:checked').each(function () {
            if (this.checked) {
                if (!contentTypeFilter) {
                    contentTypeFilter = $(this).attr('value');
                } else if (contentTypeFilter.length > 0) {
                    contentTypeFilter += ' OR ' + $(this).attr('value');
                }
            }
        });


        if (contentTypeFilter) {
            queryStringData.fl_ContentType = contentTypeFilter;
        }
    }

    //Semantic Search Click
    $(document).on('click', '#btnAdvancedSearch', function () {
        var queryStringData = {};
        
        // All methods add relevant objects to queryStringData so we can hook it all together at the end
        doOwnedContentSearch(queryStringData);
        doContentTypeFilterSearch(queryStringData);
        doQbSearch(queryStringData);
        doAdvancedBoundingCoordinatesSearch(queryStringData);
        doDateRangeSearch(queryStringData);
        doPublisherSearch(queryStringData);

        performSearch(queryStringData);
    });

    $(document).on('click', '#btnAdvancedSearchClear', function () {
        // reset access-filter-option
        $('.access-filter-option input:radio').prop('checked', false);
        $('.access-filter-option input:radio[default]').prop('checked', false);
        // reset contentTypeFilter
        resetContentTypeFilter();
        // reset authorSearchFilters
        $('#advancedAuthorSearch input:text').val('');
        $('#journalFiltersAuthorSearch input:checkbox').prop('checked', false);
        //reset qb
        $('#js_qb_groups .js_qb_group:not(:first)').remove();
        $('#js_qb_groups .js_qb_terms_list li').slice(2).remove();
        $('#js_qb_groups .js_qb_advanced_search_text').val('');
        $('#js_qb_groups #exactMatch').prop('checked', false);
        $('#js_qb_groups .js_qb_filter_select')
            .each(function(i, x) {
                var defaultValue = $(this).find('[default]').val();
                $(this).val(defaultValue);
            });
        $('#js_qb_groups .js_qb_data[name=boolOperator]').val(0);
        //reset boundCoord map
        SCM.BoundingCoordinates.loadBoundCoordScript();
    });

    //BoundingCoordinates Search
    function doAdvancedBoundingCoordinatesSearch(queryStringData) {

        var txtBoundCordNorth = $('#txtBoundCordNorth');
        var txtBoundCordEast = $('#txtBoundCordEast');
        var txtBoundCordWest = $('#txtBoundCordWest');
        var txtBoundCordSouth = $('#txtBoundCordSouth');
        

        if (txtBoundCordNorth.val() != undefined && txtBoundCordNorth.val().length > 0
            && txtBoundCordEast.val() != undefined && txtBoundCordEast.val().length > 0
            && txtBoundCordWest.val() != undefined && txtBoundCordWest.val().length > 0
            && txtBoundCordSouth.val() != undefined && txtBoundCordSouth.val().length > 0) {

            var intBoundCordNorth = parseFloat(txtBoundCordNorth.val());
            var intBoundCordEast = parseFloat(txtBoundCordEast.val());
            var intBoundCordWest = parseFloat(txtBoundCordWest.val());
            var intBoundCordSouth = parseFloat(txtBoundCordSouth.val());

            var minX = intBoundCordWest.toString();
            var maxX = intBoundCordEast.toString();

            var minY = intBoundCordSouth.toString();
            var maxY = intBoundCordNorth.toString();

            queryStringData.exPrm_fq = 'data_geo_marker:"Intersects(ENVELOPE(' + minX + ',' + maxX + ',' + maxY + ',' + minY + '))"';
            queryStringData.boundCoordSearch = true;
        }
    }

    // GeoRef Limiters Search
    $(document).on('click', '#btnAdvancedSearchLimiterSearch', function () {
        doGeoRefLimitersSearch();
    });

    $(document).on('click', '#btnAdvancedSearchLimiterSearchClear', function () {
        $('.widget-GeoRefLimiterSearch select').val(0);
        $('.widget-GeoRefLimiterSearch input:checkbox').prop('checked', false);
    });

    function doGeoRefLimitersSearch() {
        var data = {};
        data.q = '';
        var redirectUrl = '/search-results?' + $.param(data);
        var documentTypeChecked = [];
        
        var languageSelected = $('.limiter-language option:selected').val();
        var bibliographicSelected = $('.limiter-bibliographic option:selected').val();
        var documentTypeSelected = $('.limiter-document-type');
        

        if (languageSelected.length > 0 && languageSelected !== 'No Preference') {
            redirectUrl = redirectUrl + '&fl_Language=' + languageSelected;
        }
        
        if (bibliographicSelected.length > 0 && bibliographicSelected !== 'No Preference') {
            redirectUrl = redirectUrl + '&fl_GeoRefBibliographicLevel=' + bibliographicSelected;
        }
        
        
        documentTypeSelected.each(function () {
            var documentTypeObj = $(this);
            if (documentTypeObj.is(':checked')) {
                documentTypeChecked.push(documentTypeObj.val());
            }
        });

        if (documentTypeChecked.length > 0) {
            var summaryOnlyFilter = documentTypeChecked.indexOf('Meeting Abstracts') > -1 ? '&fl_GeoRefSummaryOnly=true' : '';
            if (documentTypeChecked.indexOf('Conference document') > -1 && documentTypeChecked.indexOf('Meeting Abstracts') > -1) {
                documentTypeChecked.splice($.inArray('Conference document', documentTypeChecked), 1);
            }

            var docuemntTypeQueryStringValue = documentTypeChecked.join(' OR ');
            docuemntTypeQueryStringValue = docuemntTypeQueryStringValue.replace('Meeting Abstracts', 'Conference document');
            redirectUrl = redirectUrl + '&fl_GeoRefDocumentType=' + encodeURIComponent(docuemntTypeQueryStringValue) + summaryOnlyFilter;
        }

        var searchSiteUrl = $('#hfSiteURL').val();
        window.location.href = window.location.protocol + '//' + searchSiteUrl + redirectUrl + '&f_ContentType=GeoRef Record&searchType=advanced';
    }

    // GeoRef Limiters Search
    $(document).on('click', '#btnAdvancedSearchCategoryCodeFilterSearch', function () {
        doGeoRefCategoryCodeFilterSearch();
    });

    function doGeoRefCategoryCodeFilterSearch() {
        var data = {};
        data.q = '';
        var redirectUrl = '/search-results?' + $.param(data);
        var categoryCodeSelected = $('#categorycodefilter-dropdown :selected').val();
        if (categoryCodeSelected.length > 0 && categoryCodeSelected !== 'No Preference') {
            redirectUrl = redirectUrl + '&f_GeoRefCategoryCode=' + categoryCodeSelected;

            var searchSiteUrl = $('#hfSiteURL').val();
            window.location.href = window.location.protocol + '//' + searchSiteUrl + redirectUrl + '&searchType=advanced';
        }
    }

    function doDateRangeSearch(queryStringData) {
        //Date Range
        var startDate = $('#startDateAuthor').val();
        if (startDate && startDate.length) {
            if (isYearOnly(startDate)) {
                startDate = updateYearOnlyToFullDate($('#startDateAuthor'), true);
            }

            if (!isValidDate(startDate)) {
                alert('please enter valid start date');
                queryStringData.error = true;
            }

            var endDate = $('#endDateAuthor').val();
            if (endDate && endDate.length) {
                if (isYearOnly(endDate)) {
                    endDate = updateYearOnlyToFullDate($('#endDateAuthor'), false);
                }

                if (!isValidDate(endDate) || new Date(endDate) < new Date(startDate)) {
                    alert('please enter valid end date');
                    queryStringData.error = true;
                }
            }
            else {
                $('#endDateAuthor').val(new Date().today());
                endDate = $('#endDateAuthor').val();
            }

            queryStringData.rg_PublicationDate = startDate + ' TO ' + endDate;
        } // End of Date Range
    }


    function doPublisherSearch(queryStringData) {

        var journalIds = [];
        var journalHistIds = [];
        var journalDisplayName = null;
        var currentJournalDisplayName = null;
        var isJournalSearch = false;

        $('.advancedAuthorSearch #chkAuthorJournal:checked').each(function () {
            isJournalSearch = true;
            currentJournalDisplayName = $(this).attr('currentjournaldisplayname');
            journalDisplayName = $(this).attr('text');
            journalHistIds.push($(this).attr('value'));
            journalIds.push($(this).attr('jid'));
        });

        if (isJournalSearch) {
            var journalHistIdquery = journalHistIds.join(' OR ');
            var journalIdquery = journalIds.join(' OR ');

            queryStringData.restypeid = 3;
            
            if (journalHistIds.length === 1) {
                var journalFacetName = journalDisplayName;
                if (journalDisplayName === currentJournalDisplayName) {
                    queryStringData.fl_JournalID = journalIdquery;
                    queryStringData.f_JournalDisplayName = journalFacetName;
                } else {
                    queryStringData.fl_JournalID = journalIdquery;
                    queryStringData.f_JournalDisplayName = currentJournalDisplayName;
                    queryStringData.fd_LegacyJournalDisplayName = journalFacetName;
                }
                
            } else if (journalHistIds.length > 1) {
                //multiple journals selected; some could be Legacy and some could be Current
                //Pass JournalHistID because the list could contain some legacy journals.
                queryStringData.fl_JournalHistID = journalHistIdquery;

            } else if (journalHistIds.length === 0) {
                //If all journals, tag this to querystring
                queryStringData.allJournals = 1;
            }
        }
    }


    // ----
    // DOI Search
    // ----

    //DOI Keypress
    $(document).on('keydown', '#Doi', function (e) {
        if (e.keyCode == 13) {
            GetDoiUrl();
            $('#aDoiSearch').click();
        }
    });

    // ----
    // Book Query
    // ----
    function getBookQueryParams(bookIds, bookDisplayName) {
        var bookQueryString = '&restypeid=1';
        var bookIdQuery = bookIds.join(' OR ');

        if (SCM.AdvancedSearch.configSettings.preSelectSingleBookFacet == 'true' && bookIds.length === 1) {
            bookQueryString = bookQueryString + '&f_BookDisplayName=' + encodeURIComponent($.trim(bookDisplayName)) + '&fl_BookID=' + bookIdQuery;
        } else if (bookIds.length > 0) {
            bookQueryString = bookQueryString + '&fl_BookID=' + bookIdQuery;
        } else if (bookIds.length === 0) {
            bookQueryString = bookQueryString + '&allBooks=1';
        }

        return bookQueryString;
    }

    // ----
    // Expand and Collapse Sections
    // ----
    // Expand and collapse sections
    $(document).on('click', '.toggle-expanded', function () {
        $(this).parents('.search-module').toggleClass('collapsed').toggleClass('expanded');
    });

    // ---- Query Builder 

    var qbAddTerm = function () {
        var template = $('#js_qb_term_template').html();
        var list = $(this).siblings('.js_qb_terms_list');
        list.append(template);
    };

    var initializeQbAddTermsButton = function () {
        // clearing click events first to prevent extra calls
        $('.js_qb_add_term').off('click', qbAddTerm);
        $(document).on('click', '.js_qb_add_term', qbAddTerm);
    };

    $(document).on('click', '.js_qb_add_group', function () {
        var template = $('#js_qb_group_template').html();
        var list = $(this).siblings('#js_qb_groups');
        list.append(template);

        initializeQbAddTermsButton();
    });

    initializeQbAddTermsButton();

    function createQbJson() {
        var jsonObj = [];

        //for each group
        $('#js_qb_groups .js_qb_group').each(function () {

            var group = {};

            // add conditional to the group (if exists)
            $(this).children('.row').children('.js_qb_data').each(function () {

                var elementTitle = $(this).attr('data-qb-json-element');
                group[elementTitle] = $(this).val();
            });

            var terms = [];
            // for each term in the group
            $(this).find('.js_qb_term').each(function () {

                var term = {};

                // for each data element in the term
                $(this).find('.js_qb_data').each(function () {

                    var elementTitle = $(this).attr('data-qb-json-element');

                    if (elementTitle === 'exactMatch') {
                        term[elementTitle] = $(this).is(':checked');
                    }
                    else {
                        term[elementTitle] = $(this).val();
                    }
                });

                // only add the term if there was a value entered
                if (term.input && term.input.length) {
                    terms.push(term);
                }
            });

            // only add the group is there are terms in it
            if (terms.length) {

                // ensures that the first term in a group does not contain the conditon property
                if (terms[0].condition) {
                    delete terms[0].condition;
                }

                group['terms'] = terms;
                jsonObj.push(group);
            }
        });

        // ensures that the first group in the obj does not contain the condition property
        if (jsonObj.length) {
            if (jsonObj[0].condition) {
                delete jsonObj[0].condition;
            }
        }

        return jsonObj;
    }

    // Returns the stringified Json, or empty string
    function doQbSearch(queryStringData) {
        var qbJson = createQbJson();

        // Verify that the search contains a group, otherwise assume null search
        if (qbJson.length) {
            queryStringData.cqb = JSON.stringify(qbJson);
        }
    }

    // ---- END Query Builder 

    // Paramaterize the query string, and initiate the search
    function performSearch(queryStringData) {

        // In case of an error, prevent the search 
        // Methods which add the error property to queryStringData are responsible for messaging.
        if (queryStringData.error) {
            return '';
        }

        queryStringData.searchType = 'advanced';
        //set Model.Search.AdvancedSearch to true to hide GeoRef term session var
        queryStringData.adv = true;

        var sitePath = $('#hfSiteURL').val();
        var searchResultsPath = isBoundingCoordinatesSearch(queryStringData)
            ? '/map-results'
            : '/search-results';
        var redirectUrl = sitePath + searchResultsPath + '?' + $.param(queryStringData);

        window.location.href = window.location.protocol + '//' + redirectUrl;
    }
    
    function isBoundingCoordinatesSearch(queryStringData) {
        return queryStringData.exPrm_fq && queryStringData.exPrm_fq.includes('data_geo_marker');
    }

    function populateAdvancedSearchFromReferringUrl() {
        if (document.referrer) {
            let referrerSearchParams = new URL(document.referrer).searchParams;

            populateContentAccessSearch(referrerSearchParams);
            populateContentTypeSearch(referrerSearchParams);
            populateQueryBuilderSearch(referrerSearchParams);
            populateBoundarySearch(referrerSearchParams);
            populateDateRangeSearch(referrerSearchParams);
            populatePublicationSearch(referrerSearchParams);
            populateGeoRefCategorySearch(referrerSearchParams);
            populateGeoRefLimitsSearch(referrerSearchParams);
        }
    }

    function populateContentAccessSearch(referrerSearchParams) {
        let openAcessContent = referrerSearchParams.get('access_openaccess') === 'true';
        let freeContent = referrerSearchParams.get('access_free') === 'true';
        let unlockedContent = referrerSearchParams.get('access_unlocked') === 'true';

        if (openAcessContent || freeContent || unlockedContent) {
            $('#rbtContentOwned').trigger('click');
        }
    }

    function populateContentTypeSearch(referrerSearchParams) {
        let contentType = referrerSearchParams.get('fl_ContentType');

        if (contentType) {
            //Remove the default checks
            $('.advanced-search-content-type').prop('checked', false);

            // Regex to split around " OR "
            var contentTypes = contentType.split(/\sOR\s/);

            contentTypes.forEach(function (contentType) {
                $(`.advanced-search-content-type[value="${contentType}"]`).prop('checked', true);
            });
        }
    }

    function populateQueryBuilderSearch(referrerSearchParams) {
        let queryBuilderData = referrerSearchParams.get('cqb');
        if (queryBuilderData) {
            let queryBuilderJson = JSON.parse(queryBuilderData);

            // Add enough groups to hold everything on the page
            var groupsToAdd = queryBuilderJson.length - 1;
            for (var i = 0; i < groupsToAdd; i++) {
                $('.js_qb_add_group').trigger('click');
            }

            // For each group
            for (var i = 0; i < queryBuilderJson.length; i++) {
                var group = queryBuilderJson[i];
                var groupElement = $('#js_qb_groups .js_qb_group').eq(i);

                if (group.condition) {
                    groupElement.find('select[data-qb-json-element="condition"]').val(group.condition);
                }

                // Add enough terms for the group
                var termsToAdd = group.terms.length - 2;
                for (var j = 0; j < termsToAdd; j++) {
                    groupElement.find('.js_qb_add_term').trigger('click');
                }


                // Populate the terms
                for (var j = 0; j < group.terms.length; j++) {
                    var term = group.terms[j];
                    var termElement = groupElement.find('.js_qb_term').eq(j);

                    if (term.condition) {
                        termElement.find('select[data-qb-json-element="condition"]').val(term.condition);
                    }

                    termElement.find('select[data-qb-json-element="filter"]').val(term.filter);
                    termElement.find('input[data-qb-json-element="input"]').val(term.input);

                    if (term.exactMatch) {
                        termElement.find('input[data-qb-json-element="exactMatch"]').trigger('click');
                    }
                }
            }
        }
    } 

    function populateBoundarySearch(referrerSearchParams) {
        let boundedCoordParamString = referrerSearchParams.get('exPrm_fq');
        if (isValidBoundedCoordinates(boundedCoordParamString)) {
            var envelope = boundedCoordParamString.match(/ENVELOPE\((.*?)\)/);
            var coords = envelope[1].split(',');

            // this will work anywhere except for searches around the anti meridian.
            // unfortunately because the order of the coordinates is altered when creating the Envelope string, 
            // there is no way to fix the anti meridian case (without also altering the back end).

            $('#txtBoundCordWest').val(coords[0]);
            $('#txtBoundCordEast').val(coords[1]);
            $('#txtBoundCordNorth').val(coords[2]);
            $('#txtBoundCordSouth').val(coords[3]);
        }
    }

    function populateDateRangeSearch(referrerSearchParams) {
        let dateRange = referrerSearchParams.get('rg_PublicationDate');
        if (dateRange) {
            var dates = dateRange.split(/\sTO\s/);
            $('#startDateAuthor').val(dates[0]);
            $('#endDateAuthor').val(dates[1]);
        }
    }

    function populatePublicationSearch(referrerSearchParams) {
        let journalId = referrerSearchParams.get('fl_JournalID');
        let journalHistId = referrerSearchParams.get('fl_JournalHistID');

        // this is used when only 1 publication is selected
        if (journalId) {
            $(`.advancedSearchJournal[jid="${journalId}"]`).trigger('click');
        }

        // this is used if more than 1 publication was selected
        if (journalHistId) {
            var journalIds = journalHistId.split(/\sOR\s/);

            journalIds.forEach(function (id) {
                $(`.advancedSearchJournal[value="${id}"]`).trigger('click');
            });
        }
    }

    function populateGeoRefCategorySearch(referrerSearchParams) {
        let geoRefCategoryCode = referrerSearchParams.get('f_GeoRefCategoryCode');

        if (geoRefCategoryCode) {
            $('#categorycodefilter-dropdown').val(geoRefCategoryCode);
        }
    }

    function populateGeoRefLimitsSearch(referrerSearchParams) {
        let language = referrerSearchParams.get('fl_Language');
        let geoRefBibliographicLevel = referrerSearchParams.get('fl_GeoRefBibliographicLevel');
        let geoRefDocumentType = referrerSearchParams.get('fl_GeoRefDocumentType');

        if (language) {
            $('#limiter-language').val(language);
        }

        if (geoRefBibliographicLevel) {
            $('#limiter-bibliographic').val(geoRefBibliographicLevel);
        }

        if (geoRefDocumentType) {
            var docTypes = geoRefDocumentType.split(/\sOR\s/);

            docTypes.forEach(function (docType) {
                $(`.limiter-document-type[value="${docType}"]`).trigger('click');
            });
        }
    }

    populateAdvancedSearchFromReferringUrl();

}); // END $(document).ready()





// ----
// Datepicker Keyboard Adjustments
// ----
// This prevents the form submitting when pressing enter while on the datepicker. 
// It is waaaaaaayy too long. 
$(function () {
    try {


        $('#startDateSemanticSearch').on('keydown', function (e) {
            // http://stackoverflow.com/questions/15235499/jquery-ui-datepicker-prevent-enter-selecting-when-readonly
            if (e.which == 13) {
                var startDateSemanticSearch = $('#startDateSemanticSearch').val();
                if (isYearOnly(startDateSemanticSearch)) {
                    updateYearOnlyToFullDate($('#startDateSemanticSearch'), true);
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    return false;
                }
            }
        });

        $('#endDateSemanticSearch').on('keydown', function (e) {
            // http://stackoverflow.com/questions/15235499/jquery-ui-datepicker-prevent-enter-selecting-when-readonly
            if (e.which == 13) {
                var endDateSemanticSearch = $('#endDateSemanticSearch').val();
                if (isYearOnly(endDateSemanticSearch)) {
                    updateYearOnlyToFullDate($('#endDateSemanticSearch'), true);
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    return false;
                }
            }
        });

        $('#startDateAuthor').on('keydown', function (e) {
            // http://stackoverflow.com/questions/15235499/jquery-ui-datepicker-prevent-enter-selecting-when-readonly
            if (e.which == 13) {
                var startDateAuthor = $('#startDateAuthor').val();
                if (isYearOnly(startDateAuthor)) {
                    updateYearOnlyToFullDate($('#startDateAuthor'), true);
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    return false;
                }
            }
        });

        $('#endDateAuthor').on('keydown', function (e) {
            // http://stackoverflow.com/questions/15235499/jquery-ui-datepicker-prevent-enter-selecting-when-readonly
            if (e.which == 13) {
                var endDateAuthor = $('#endDateAuthor').val();
                if (isYearOnly(endDateAuthor)) {
                    updateYearOnlyToFullDate($('#endDateAuthor'), true);
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    return false;
                }
            }
        });


    } catch (e) { }
});










